import React, {useState, useEffect} from 'react';
import { Container, Card }          from 'react-bootstrap';
import api                          from './AxiosConfig'; 
import { BsFillTrashFill,
         BsPatchPlusFill,
         BsPatchMinusFill }         from "react-icons/bs";

function GoalProgressUpdateMG( props ) {
  const [message,         setMessage]         = useState( "" );
  const [messageErr,      setMessageErr]      = useState( "" );
  const [allocated,       setAllocated]       = useState( [] );
  const [unallocated,     setUnAllocated]     = useState( [] );
  const [archived,        setArchived]        = useState( [] );
  const [goal,            setGoal]            = useState( {} );
  const [refreshAlloc,    setRefreshAlloc]    = useState(true);
  const [refreshUnAlloc,  setRefreshUnAlloc]  = useState(true);
  const [refreshArchived, setRefreshArchived] = useState(true);
  
  useEffect(() => {
      if (props && props.goal) {
          setGoal(props.goal);
      }
  }, [props]);

  useEffect(() => {
      async function getAllocatedGoals() {
          if ( refreshAlloc && goal && goal.id ) {
              try {
                  const response = await api.get(`/site/goals/allocated-to/${encodeURIComponent(goal.id)}`, {withCredentials: true });
                  setAllocated(response.data);
                  setRefreshAlloc(false);
              } catch (error) {
                  console.log("getGoalProgress: " + error);
              }
          }
      }
      getAllocatedGoals();
  }, [goal, refreshAlloc]); 

  useEffect(() => {
      async function getUnAllocatedGoals() {
          if ( refreshUnAlloc && goal && goal.id ) {
              try {
                  const response = await api.get(`/site/goals/allocated-to/0`, {withCredentials: true });
                  setUnAllocated(response.data);
                  setRefreshUnAlloc(false);
              } catch (error) {
                  console.log("getGoalProgress: " + error);
              }
          }
      }
      getUnAllocatedGoals();
  }, [goal, refreshUnAlloc]); 

  useEffect(() => {
      async function getArchivedGoals() {
          if ( refreshArchived && goal && goal.id ) {
              try {
                  const response = await api.get(`/site/goals/archived`, {withCredentials: true });
                  setArchived(response.data);
                  setRefreshArchived(false);
              } catch (error) {
                  console.log("getGoalProgress: " + error);
              }
          }
      }
      getArchivedGoals();
  }, [goal, refreshArchived]); 

  const handleAddChild = async ( ch ) => {
      console.log("Add child goal " + unallocated[ch].id );
      try {
            const response = await api.put(`/site/goals/allocated-to/${encodeURIComponent(unallocated[ch].id)}/${encodeURIComponent(goal.id)}`, {}, {withCredentials: true });
            setMessage( response.data.message );
            setMessageErr( !response.data.success );
            setRefreshAlloc(true);
            setRefreshUnAlloc(true);
            setRefreshArchived(true);
      } catch (error) {
            if (error.response) {
                // The updated goal record is returned if the update was successful.
                setMessage(error.response.data.message);  // Display error message from server
                setMessageErr( true );
            } else {
                setMessage('An error occurred while deleting');
                setMessageErr( true );
            }
        }    
  };

const handleDeArchiveChild = async ( ch ) => {
      console.log("De-archive goal " + archived[ch].id );
      try {
            const response = await api.put(`/site/goals/archived/${encodeURIComponent(archived[ch].id)}/0`, {}, {withCredentials: true });
            setMessage( response.data.message );
            setMessageErr( !response.data.success );
            setRefreshAlloc(true);
            setRefreshUnAlloc(true);
            setRefreshArchived(true);
      } catch (error) {
            if (error.response) {
                // The updated goal record is returned if the update was successful.
                setMessage(error.response.data.message);  // Display error message from server
                setMessageErr( true );
            } else {
                setMessage('An error occurred while deleting');
                setMessageErr( true );
            }
        }    
  };

  const handleRemoveChild = async ( ch ) => {
      console.log("Remove child goal " + allocated[ch].id );
      try {
            const response = await api.put(`/site/goals/allocated-to/${encodeURIComponent(allocated[ch].id)}/0`, {}, {withCredentials: true });
            setMessage( response.data.message );
            setMessageErr( !response.data.success );
            setRefreshAlloc(true);
            setRefreshUnAlloc(true);
            setRefreshArchived(true);
      } catch (error) {
            if (error.response) {
                // The updated goal record is returned if the update was successful.
                setMessage(error.response.data.message);  // Display error message from server
                setMessageErr( true );
            } else {
                setMessage('An error occurred while deleting');
                setMessageErr( true );
            }
        }
    
  };
  
  const handleDeleteOrphan = async ( og ) => {
      console.log("handleDeleteOrphan" + archived[og].id );
      try {
            const response = await api.delete(`/site/goals/${encodeURIComponent(archived[og].id)}`, {withCredentials: true });
            setMessage( response.data.message );
            setMessageErr( !response.data.success );
            setRefreshAlloc(true);
            setRefreshUnAlloc(true);
            setRefreshArchived(true);
      } catch (error) {
            if (error.response) {
                // The updated goal record is returned if the update was successful.
                setMessage(error.response.data.message);  // Display error message from server
                setMessageErr( true );
            } else {
                setMessage('An error occurred while deleting');
                setMessageErr( true );
            }
        }
    
  }

  const handleArchiveOrphan = async ( og ) => {
      console.log("handleArchiveOrphan" + unallocated[og].id );
      try {
            const response = await api.put(`/site/goals/archived/${encodeURIComponent(unallocated[og].id)}/1`, {}, {withCredentials: true });
            setMessage( response.data.message );
            setMessageErr( !response.data.success );
            setRefreshAlloc(true);
            setRefreshUnAlloc(true);
            setRefreshArchived(true);
      } catch (error) {
            if (error.response) {
                // The updated goal record is returned if the update was successful.
                setMessage(error.response.data.message);  // Display error message from server
                setMessageErr( true );
            } else {
                setMessage('An error occurred while deleting');
                setMessageErr( true );
            }
        }
    
  }
  
  return (
    <div>
      {props.goal ? (
        <Container>
           <Card className="scrollable-container border p-3" >
           <h2 className="mt-4">Edit Values</h2>
           <div><div class="card-goal-header">Children</div>
              { allocated.map((value, index) => (
                <div class='card-subgoal-alloc' key={index}><BsPatchMinusFill onClick={() => handleRemoveChild( index )} /> {value.goal_title}({value.id})</div> ) )}
           </div>
                
           <div><div class="card-goal-header">Unallocated</div>
              { unallocated.map((value, index) => (
                <div class='card-subgoal-unalloc' key={index}><BsPatchPlusFill onClick={() => handleAddChild( index )} /> {value.goal_title}({value.id}) 
                <BsFillTrashFill onClick={() => handleArchiveOrphan( index )}/>
                </div> ) )}
           </div>
           <div><div class="card-goal-header">Archived</div>
              { archived.map((value, index) => (
                <div class='card-subgoal-unalloc' key={index}><BsPatchPlusFill onClick={() => handleDeArchiveChild( index )} /> {value.goal_title}({value.id}) 
                <BsFillTrashFill onClick={() => handleDeleteOrphan( index )}/>
                </div> ) )}
           </div>
           </Card>
         <p className={'message-err-' + messageErr }>{message}</p>
         </Container>
      ) : (
        <p>No PS Goal received.</p>
      )}
    </div>
  );
}

export default GoalProgressUpdateMG;
